"use client";

import { useSearchParams, useRouter } from "next/navigation";
import { motion } from "framer-motion";

const FilterCategories: React.FC = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const selectedCategory = searchParams.get("category") || "Todos";

  const categories = [
    { label: "Todos", value: "Todos" },
    { label: "Sobre a Click", value: "Sobre a Click" },
    { label: "Tratamento", value: "Tratamento" },
    { label: "Como funciona", value: "Como funciona" },
    { label: "Legislação", value: "Legislação" },
    { label: "Outros", value: "Outros" },
    { label: "Importação", value: "Importação" },
  ];

  const handleCategoryChange = (category: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("category", category);
    router.push(`?${params.toString()}`, { scroll: false });
  };

  return (
    <>
      {categories.map((category) => (
        <motion.button
          key={category.value}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleCategoryChange(category.value)}
          className={`flex-shrink-0 whitespace-nowrap rounded-xl px-4 py-2 ${
            selectedCategory === category.value
              ? "bg-[#E7EDE7BF] text-black"
              : "bg-white text-gray-500"
          }`}
        >
          {category.label}
        </motion.button>
      ))}
    </>
  );
};

export default FilterCategories;
